import Vue from 'vue'
import VueEvents from 'vue-events'
import Vuelidate from 'vuelidate'
import VueTour from 'vue-tour'
//import VueMatomo from 'vue-matomo'
import VueCookies from 'vue-cookies'
import App from './layouts/App.vue'
import API from '@/services/api'
import vuetify from './plugins/vuetify'
import router from '@/router'
import store from '@/store'
import i18n from '@/locale'
import '@/filters'
import get from 'lodash/get'

import { Notifier } from '@airbrake/browser'

import '@/styles/main.scss'

import './registerServiceWorker'

Vue.config.productionTip = false

//- Airbrake error logging
if (process.env.VUE_APP_AIRBRAKE_PROJECT && process.env.VUE_APP_AIRBRAKE_KEY) {
  let airbrake = new Notifier({
    environment: 'production',
    projectId: process.env.VUE_APP_AIRBRAKE_PROJECT,
    projectKey: process.env.VUE_APP_AIRBRAKE_KEY
  })
  Vue.config.errorHandler = function (err, vm, errinfo) {
    airbrake.notify({
      context: { component: 'minasidor' },
      error: err,
      params: { info: errinfo }
    })
  }
}

//- Define a scroll to top function to use with vue-router if opeing same route (with different content) twice
Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0)

// Add commonly used fuctions to global context
Vue.set(Vue.prototype, 'loGet', get);

//- Validations for forms and such
Vue.use(Vuelidate)
Vue.use(VueEvents)
Vue.use(VueCookies)
Vue.use(require('vue-shortkey'), { prevent: ['textarea'] })

require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

// REMOVE COMMENT WHEN MATOMO IS NEEDED
/* Vue.use(VueMatomo, {
  // Configure your matomo server and site by providing
  host: 'http://tullbox.local/',
  siteId: 2,
  trackerFileName: 'matomo',
  router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: false,
  enableHeartBeatTimer: false,
  heartBeatTimerInterval: 15,
  debug: false,
  cookieDomain: undefined,
  domains: undefined,
  preInitActions: []
}) */

// Initialize what needs to be initialized and start up application
Promise.all([API.init(), store.dispatch('init')]).then(
  new Vue({
    vuetify,
    router,
    store,
    i18n,
    created() {
      API.dialog = this.$dialog
      API.events = this.$events
      API.store = this.$store
    },
    render: h => h(App)
  }).$mount('#app')
)
